import React from "react";
import hero from "../assets/img/Industries/Pharma_hero.jpg";
import doc_sub_1 from "../assets/img/Industries/pharma_sub_1.jpg";
import doc_sub_2 from "../assets/img/Industries/pharma_sub_3.jpg";
import DownloadBrochure from "./DownloadBrochure";
import { Link as RouterLink } from 'react-router-dom';


const PharmaIndustry = () => {

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="pharma" className="about text-start" style={{paddingTop:'40px'}}>
                    <div className="ph-hero">
                        <div className="ph-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <div className="ph-title-content">
                                <h1>Powerful Pharmaceutical Softwares</h1>
                                <p>Streamline every stage of drug development with a compliant, centralized, and fully searchable system. Enhance lab efficiency, foster seamless collaboration, and accelerate time-to-market with an integrated pharma LIMS.</p>
                            </div>
                            <div className="book_a_demo">
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        <div className="ph-hero-img  carousel-container animate__animated animate__fadeInRight" data-aos="fade-right" data-aos-delay="100">
                            <img src={hero} alt="pharma lab" />
                        </div>
                    </div>

                    <div className="section-container" style={{marginTop:'0'}}>
                        <div className="row">
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={doc_sub_1} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Maximizing Efficiency & Compliance with Pharmaceutical Lab Iconics LIMS</h1></div>
                                        <ul>
                                            <li><b>Comprehensive Drug Development Management – </b>Streamline workflows from R&D to quality control, ensuring compliance with FDA, GxP, and ISO regulations.</li>
                                            <li><b>Automation & Data Integrity – </b>Automate sample tracking, test scheduling, and reporting while ensuring secure, tamper-proof records with electronic signatures and audit trails.</li>
                                            <li><b>Accelerated Product Approval – </b> Speed up regulatory submissions with real-time data access, standardized documentation, and advanced analytics for faster decision-making.</li>
                                            <li><b>Seamless Integration & Collaboration – </b> Connect with HPLC, GC, Spectrometers, ERP, ELN, and MES systems while enhancing collaboration between R&D, QA, and regulatory teams.</li>
                                            <li><b>Scalability & Cloud Accessibility  – </b> Future-proof pharma operations with a scalable, cloud-enabled LIMS supporting remote access and multi-site laboratory collaboration for efficiency.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sec-out" style={{paddingTop:'2rem'}}>
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={doc_sub_2} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Optimizing Lab Performance & Compliance with Lab Iconics LIMS</h1></div>
                                        <ul>
                                            <li><b>Optimized Lab Workflows – </b> Automate sample tracking, instrument calibration, and test scheduling to improve efficiency, minimize errors, and enhance operational accuracy.</li>
                                            <li><b>Regulatory-Ready Data Management – </b> Maintain secure, tamper-proof records with audit trails, access controls, and electronic signatures for strict regulatory compliance.</li>
                                            <li><b>Advanced Stability & Quality Control – </b> Monitor stability studies, batch testing, and environmental conditions to ensure consistent product quality and compliance with regulations.</li>
                                            <li><b>Real-Time Reporting & Analytics – </b> Gain valuable insights through automated dashboards, customizable reports, and trend analysis to enhance data-driven decision-making.</li>
                                            <li><b>Global Collaboration & Accessibility – </b> Enable multi-location teams to work seamlessly through cloud-based deployment, centralized data sharing, and remote access to critical laboratory information.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </main>
            <div data-aos="fade-up" data-aos-delay="100">
                <DownloadBrochure product={'Industries'}/>
            </div>
                
        </div>
    )
}

export default PharmaIndustry;